import { useEffect, useRef, useState } from 'react';

/**
 * HeroVideo
 * Renders a looped, muted, autoplay video reel with multiple Pexels clips.
 * Falls back to a static image if all sources fail or autoplay is blocked.
 */
export default function HeroVideo({ poster, fallback, sources }) {
  const ref = useRef(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    const v = ref.current;
    if (!v) return;
    const tryPlay = async () => {
      try {
        await v.play();
      } catch {
        // Autoplay blocked; we still keep the video element with poster.
      }
    };
    tryPlay();
  }, []);

  if (failed) {
    return (
      <img
        src={fallback}
        alt=""
        className="absolute inset-0 w-full h-full object-cover ken-burns"
      />
    );
  }

  return (
    <video
      ref={ref}
      className="absolute inset-0 w-full h-full object-cover"
      autoPlay
      muted
      loop
      playsInline
      preload="auto"
      poster={poster}
      onError={() => setFailed(true)}
      aria-hidden="true"
    >
      {sources.map((s) => (
        <source key={s.src} src={s.src} type={s.type} />
      ))}
      <img src={fallback} alt="" />
    </video>
  );
}
